import * as React from 'react';
import { ModalMain } from 'damco-components';

interface IProps {
    displayDialog: boolean,
    closeDialog:()=> void,
    message: string,
    children?: React.ReactNode | React.ReactNodeArray;
}
export const ItemCategoryCheck = (props:IProps) => {
   
    const close = () => {
        props.closeDialog()
    }
    if(props.displayDialog){
        return(
            <ModalMain height={props.children?400:100}
                modal={props.displayDialog} 
                title={'Operation not possible'} 
                hideMethod={close} 
                secondaryMethod={close} 
                primaryMethod={close} btnTitle1={'OK'} btnTitle2={'CLOSE'}>
                    <p>{props.message}</p>
                    {props.children}
            </ModalMain>
        )
    }else{
        return <div/>
    }
}